import { useState } from 'react';
import { useNavigate, Link, useSearchParams } from 'react-router-dom';
import { ArrowLeft, UserPlus } from 'lucide-react';
import { useAuth } from '@core/auth/useAuth';
import { PageHeader } from '@shared/components/ui/PageHeader';
import { CandidateForm } from './CandidateForm';
import { CandidateIntakeWizardModal, readCandidateWizardHidden } from './CandidateIntakeWizardModal';

export function CandidateNewPage() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const skipWizard = searchParams.get('nowizard') === '1' || searchParams.get('nointro') === '1';
  const [classicOnly, setClassicOnly] = useState(() => skipWizard || readCandidateWizardHidden());

  if (!user?.orgId) return null;

  return (
    <div className="w-full max-w-6xl">
      <CandidateIntakeWizardModal
        open={!classicOnly}
        onDismiss={() => navigate('/candidates')}
        onSkipClassic={() => setClassicOnly(true)}
        onDone={({ candidateIds }) => {
          const first = candidateIds[0];
          if (first) navigate(`/candidates/${first}`);
          else navigate('/candidates');
        }}
        orgId={user.orgId}
        userId={user.id}
      />

      <PageHeader
        icon={UserPlus}
        breadcrumb={[
          { label: 'Data', href: '/candidates' },
          { label: 'Candidates', href: '/candidates' },
          { label: 'New candidate' },
        ]}
        title="[Add Candidate]"
        subtitle="Create a candidate record — intake wizard or classic form"
        action={
          <Link to="/candidates" className="btn-secondary">
            <ArrowLeft className="w-4 h-4" /> Back
          </Link>
        }
      />

      {classicOnly && !skipWizard && (
        <p className="text-xs vscode-text-tertiary mb-3">
          <button
            type="button"
            className="text-brand-400 hover:text-brand-300 underline font-medium"
            onClick={() => setClassicOnly(false)}
          >
            [Open intake wizard]
          </button>
          <span className="vscode-text-tertiary opacity-70"> · </span>
          Channels (LinkedIn, Naukri, campus…), CSV/Excel import, optional job + skill fitment.
        </p>
      )}

      {skipWizard && (
        <p className="text-xs vscode-text-tertiary mb-3">
          Wizard skipped (<code className="vscode-text-tertiary">?nowizard=1</code>).
        </p>
      )}

      <div className={!classicOnly ? 'hidden' : undefined} aria-hidden={!classicOnly}>
        <CandidateForm
          mode="new"
          orgId={user.orgId}
          userId={user.id}
          onSave={(c) => navigate(`/candidates/${c.id}`)}
        />
      </div>
    </div>
  );
}
